function openTabFeed(evt, sectionId, tabName) {
  const tabcontent = document.getElementsByClassName('products-feed__tabcontent--' + sectionId);
  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = 'none';
  }

  const tablinks = document.getElementsByClassName('products-feed__tablinks--' + sectionId);
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove('active');
  }

  const tab = document.getElementById(tabName);
  if (!tab) return;

  tab.style.display = 'block';
  evt.currentTarget.classList.add('active');
}

document.querySelectorAll('[data-default-open]').forEach(el => {
  el.click();
});
